/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */
import { LOADER_STATUS,PROFILE_INFO, SET_FILING_STATUS, STORE_DROPDOWN_GSTIN, STORE_ENTITY, STORE_GSTIN, STORE_PERIOD, VENDOR_LIST } from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  // entityList:[],
  selectedEntity: "",
  selectedGstin: '',
  selectedPeriod: "",
  filingStatus: "",
};

/* eslint-disable default-case, no-param-reassign */
const gstr6CommonReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case STORE_ENTITY:
        return {
          ...state,
          selectedEntity:action.selectedEntity
        }
      case STORE_GSTIN:
        return {
          ...state,
          selectedGstin:action.selectedGstin
        }
      case STORE_PERIOD:
        return {
          ...state,
          selectedPeriod:action.selectedPeriod
        }
      case SET_FILING_STATUS:
        return {
          ...state,
          filingStatus:action.filingStatus 
        }
      case VENDOR_LIST:
        return {
          ...state,
          vendorList:action.vendorList
        }
      default:
        return state;
    }
  };

export default gstr6CommonReducer;
